import React, { useEffect } from 'react'
import {motion} from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/Location.css'
import xm1 from '../assets/images/location1.png'
import xm2 from '../assets/images/location2.png'
import xm8 from '../assets/images/fifth.png'
import ov1 from '../assets/images/ov1.png'
import ov2 from '../assets/images/ov2.png'
import ov3 from '../assets/images/ov3.png'
import ov4 from '../assets/images/ov4.png'
import ov5 from '../assets/images/ov5.png'
import ov6 from '../assets/images/ov6.png'
import ov7 from '../assets/images/ov7.png'
import ov8 from '../assets/images/ov8.png'
import ov9 from '../assets/images/ov9.png'
import ov9a from '../assets/images/m1.png'
import ov9b from '../assets/images/m2.png'
import ov9c from '../assets/images/m3.png'
import bg1a from '../assets/images/bg1a.png'
import bg1b from '../assets/images/bg1b.png'
import bg1c from '../assets/images/bg1c.png'
import bg1d from '../assets/images/bg1d.png'
import tick from '../assets/images/tickkk.png'
import ex from '../assets/images/ex (1).png'
import loc9 from '../assets/images/loc9 (1).png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'


const Location = () => {
  useEffect(()=>{
    AOS.init();
   
  })
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);
  return (
    <div>
      
       <section className="l_main">
        <div className="l_main_sec">
          <h1 >
            <span style={{ color: "#EEBD2B" }}>A Premier Business</span>
            <br /> 
Address in Uptown Houston
          </h1>

<p>Private executive offices, virtual office solutions, and conference
facilities located at 3050 Post Oak Boulevard in Houston's
prestigious Post Oak corridor.</p>

          <button>
      Schedule a Private Tour    </button>{" "}
          <button style={{ background: "#0D0D0D", color: "#EEBD2B", opacity: 1 }}>
            View Office Options
          </button>
        </div>
      </section>

<section className="prestige">
  <div className="prestige__container">
    <div className="prestige__grid">
      {/* Left */}
      <div className="prestige__content">
        <p className="prestige__kicker">
          <span className="prestige__kickerLine" />
          THE PRESTIGE
        </p>

        <h2 className="prestige__title">
          Position Your Business
          <br />
          Where Image <span>Matters</span>
        </h2>

        <p className="prestige__text">
          Operating from Houston’s Uptown district instantly elevates your company’s
          presence. Surrounded by financial institutions, luxury hotels, and high-level
          professional firms, this location reflects credibility from the moment your
          client arrives.
        </p>

        <p className="prestige__text">
          Xceed Office at 3050 Post Oak Boulevard is designed for professionals who
          understand that environment influences perception.
        </p>

        <blockquote className="prestige__quote">
          <span className="prestige__quoteBar" />
          <div className="prestige__quoteText">
            <p>“This is not casual coworking.</p>
            <p>This is executive positioning.”</p>
          </div>
        </blockquote>
      </div>

      {/* Right */}
      <div className="prestige__media">
        <div className="prestige__imageCard">
          <img className="prestige__image" src={xm1} alt="Executive office" />
        </div>
      </div>
    </div>
  </div>
</section>

{/* INSIDE 3050 POST OAK BOULEVARD */}
<section style={{background:"#171717ff"}} className="building">
  <div className="building__container">
    <div className="building__grid">
      {/* Left image */}
      <div className="building__media">
        <div className="building__imageCard">
          <img className="building__image" src={xm2} alt="Conference room" />
        </div>
      </div>

      {/* Right content */}
      <div className="building__content">
        <p className="building__kicker">
          <span className="building__kickerLine" />
          THE BUILDING
        </p>

        <h2 className="building__title">
          Inside <span>3050</span> Post Oak Boulevard
        </h2>

        <p className="building__text">
          3050 Post Oak Boulevard is a Class A office tower located in the center of
          Houston’s Uptown business district. With immediate access to Loop 610, I-10,
          and US-59, the building offers unmatched accessibility for both you and your
          clients.
        </p>

        <p className="building__text">
          The tower is minutes from The Galleria and surrounded by executive dining,
          major banking institutions, and professional services firms.
        </p>

        <div className="building__stats">
          <div className="buildingStat">
            <div className="buildingStat__value">Class A</div>
            <div className="buildingStat__label">Office Tower</div>
          </div>

          <div className="buildingStat">
            <div className="buildingStat__value">3</div>
            <div className="buildingStat__label">Major Highways</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section className="available">
  <div className="available__container">

    <div className="available__header">
      <p className="available__kicker">
        EXECUTIVE WORKSPACE SOLUTIONS
      </p>

      <h2>
        Available at This <span>Location</span>
      </h2>
    </div>

    <div className="available__grid">

      {/* Card A */}
      <div className="available__card available__bgA">
        <div className="available__overlay">
          <div className="available__icon"><img src={ov1} alt="" /></div>
          <h3>Private Executive Offices</h3>
          <p>
            Fully furnished offices built for attorneys, consultants,
            advisors, and professional teams who require privacy and focus.
          </p>
        </div>
      </div>

      {/* Card B */}
      <div className="available__card available__bgB">
        <div className="available__overlay">
          <div className="available__icon"><img src={ov2} alt="" /></div>
          <h3>Virtual Office Services</h3>
          <p>
            Establish your business at 3050 Post Oak Boulevard with a
            prestigious business address, mail handling, and optional
            live receptionist support.
          </p>
        </div>
      </div>

      {/* Card C */}
      <div className="available__card available__bgC">
        <div className="available__overlay">
          <div className="available__icon"><img src={ov3} alt="" /></div>
          <h3>Conference & Meeting Room</h3>
          <p>
            Modern meeting facilities designed for presentations,
            negotiations, and board-level discussions.
          </p>
        </div>
      </div>

      {/* Card D */}
      <div className="available__card available__bgD">
        <div className="available__overlay">
          <div className="available__icon"><img src={ov4} alt="" /></div>
          <h3>Day Offices</h3>
          <p>
            Professional private office space available on demand —
            when you need it, where you need it.
          </p>
        </div>
      </div>

    </div>
  </div>
</section>
 <section style={{background:"#171717ff"}} className="firms">
  <div className="firms__container">

    <div className="firms__grid">

      {/* LEFT CONTENT */}
      <div className="firms__content">

        <p className="firms__kicker">
          <span></span>
          WHO THIS IS BUILT FOR
        </p>

        <h2>
          Ideal for Growing & <span>Established Firms</span>
        </h2>

        <p className="firms__desc">
          If credibility is part of your competitive advantage, this location supports it
        </p>

        <div className="firms__list">

          <div className="firms__item">
            <div className="firms__icon"><img src={ov5} alt="" /></div>
            <p>Law firms</p>
          </div>

          <div className="firms__item">
            <div className="firms__icon"><img src={ov6} alt="" /></div>
            <p>CPAs and financial advisors</p>
          </div>

          <div className="firms__item">
            <div className="firms__icon"><img src={ov7} alt="" /></div>
            <p>Real estate brokerages</p>
          </div>

          <div className="firms__item">
            <div className="firms__icon"><img src={ov8} alt="" /></div>
            <p>Private equity and investment professionals</p>
          </div>

          <div className="firms__item">
            <div className="firms__icon"><img src={ov9a} alt="" /></div>
            <p>Sales organizations</p>
          </div>

          <div className="firms__item">
            <div className="firms__icon"><img src={ov9b} alt="" /></div>
            <p>International companies entering Houston</p>
          </div>

        </div>
      </div>


      {/* RIGHT IMAGE */}
      <div className="firms__image">
        <img src={xm8} alt="Office workspace" />
      </div>

    </div>

  </div>
</section>
  <section className="interior">
  <div className="interior__container">

    <header className="interior__header">
      <p className="interior__kicker">
        <span className="interior__kickerLine" />
        INTERIOR EXPERIENCE
        <span className="interior__kickerLine" />
      </p>

      <h2 className="interior__title">
        Structured, Professional, <span>Focused</span>
      </h2>

      <p className="interior__subtitle">
        Every detail supports focus and performance.
      </p>
    </header>

    <div className="interior__grid">
      <div className="interior__item">
        <span className="interior__check">✓</span>
        Professional front desk reception
      </div>

      <div className="interior__item">
        <span className="interior__check">✓</span>
        Secure high-speed enterprise internet
      </div>

      <div className="interior__item">
        <span className="interior__check">✓</span>
        Quiet productivity-driven layout
      </div>

      <div className="interior__item">
        <span className="interior__check">✓</span>
        Executive-style furnishings
      </div>

      <div className="interior__item">
        <span className="interior__check">✓</span>
        Lounge and pantry areas
      </div>

      <div className="interior__item">
        <span className="interior__check">✓</span>
        Dedicated prayer rooms
      </div>

      <div className="interior__item interior__item--span">
        <span className="interior__check">✓</span>
        Secure access control
      </div>
    </div>

  </div>
</section>
  <section style={{background:"#171717ff"}} className="scale">
  <div className="scale__container">
    <div className="scale__grid">

      {/* LEFT */}
      <div className="scale__content">
        <p className="scale__kicker">
          <span className="scale__kickerLine" />
          FLEXIBILITY TO SCALE
        </p>

        <h2 className="scale__title">
          Grow Without Losing <br />
          Your <span>Address</span>
        </h2>

        <div className="scale__steps">
          <div className="scale__step">
            <div className="scale__num">1</div>
            <p>Start with a virtual office.</p>
          </div>

          <div className="scale__step">
            <div className="scale__num">2</div>
            <p>Upgrade to a private suite.</p>
          </div>

          <div className="scale__step">
            <div className="scale__num">3</div>
            <p>Expand into multiple offices as your team grows.</p>
          </div>

          <div className="scale__step">
            <div className="scale__num">4</div>
            <p>Maintain flexibility without sacrificing prestige.</p>
          </div>
        </div>

        <p className="scale__note">
          At 3050 Post Oak Boulevard, your address remains constant even as your company evolves.
        </p>
      </div>

      {/* RIGHT */}
      <div className="scale__media">
        <div className="scale__imageCard">
          <img
            className="scale__image"
            src={xm8}
            alt="Workspace lounge"
          />
        </div>
      </div>

    </div>
  </div>


</section>
  <section className="locInfo">
  <div className="locInfo__container">

    <header className="locInfo__header">
      <p className="locInfo__kicker">
        <span className="locInfo__kickerLine" />
        LOCATION DETAILS
        <span className="locInfo__kickerLine" />
      </p>

      <h2 className="locInfo__title">
        Location <span>Information</span>
      </h2>
    </header>

    <div className="locInfo__grid">
      {/* LEFT MAP */}
      <div className="locInfo__mapCard">
        <iframe
          className="locInfo__map"
          title="3050 Post Oak Boulevard"
          src="https://www.google.com/maps?q=3050+Post+Oak+Boulevard+Houston+TX+77056&output=embed"
          loading="lazy"
        />
      </div>

      {/* RIGHT CARDS */}
      <div className="locInfo__cards">

        <div className="locInfoCard">
          <div className="locInfoCard__top">
            <span className="locInfoCard__icon"> <img src={ov9a} alt="" /> </span>
            <h3>Address</h3>
          </div>

          <p>
            Xceed Office <br />
            3050 Post Oak Boulevard <br />
            Houston, Texas 77056
          </p>
        </div>

        <div className="locInfoCard">
          <div className="locInfoCard__top">
            <span className="locInfoCard__icon"><img src={ov9b} alt="" /></span>
            <h3>Area</h3>
          </div>

          <p>
            Located in Houston’s Uptown / Galleria area with direct access to Loop 610
            and minutes from major highways.
          </p>
        </div>

        <div className="locInfoCard">
          <div className="locInfoCard__top">
            <span className="locInfoCard__icon"><img src={ov9c} alt="" /></span>
            <h3>Parking</h3>
          </div>

          <p>On-site parking available.</p>
        </div>

      </div>
    </div>

  </div>
</section>
 
   {/* ✅ CTA SECTION (ADDED) */}
      <section style={{background:"#171717ff"}}className="cta">
        <div className="cta__wrap">
          <h2 className="cta__title">
            Ready to Elevate Your <br />
            <span>Business Presence?</span>
          </h2>

          <p className="cta__sub">
            Join professionals who trust Xceed Office for their workspace <br />
            needs.
          </p>

          <div className="cta__actions">
            <button className="cta__btn cta__btn--primary" type="button">
              <span className="cta__btnIcon"><IconCalendar /></span>
              Schedule a Tour <span className="cta__arrow">→</span>
            </button>

            <button className="cta__btn cta__btn--ghost" type="button">
              <span className="cta__btnIcon"><IconCall /></span>
              Call Now
            </button>
          </div>


        </div>
      </section>


    </div>
  )
}

export default Location